import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import ProjectHistoryList from "../ProjectHistory/ProjectHistoryList";


class AndroidPlatform extends BaseSizeSensitiveComponent {

    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);
        var filters = { industries: ['Financial','Insurance',], andTechs: false, techs: [], andSearch: false, search: [], };

        return (

            <div style={this.styler.currStyles.Container}>
                <div style={this.styler.currStyles.Header}>
                    <p style={this.styler.currStyles.Header.Title}>Experience and Capabilities in the Financial and Insurance Industries</p>
                </div>
                <div style={this.styler.currStyles.Body}>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}>I have experience and skill that will allow me to develop systems for the Financial and Insurance industries.</p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                        <p style={this.styler.currStyles.Body.TextPage.Section.paragraph}></p>
                    </div>
                    <br/>
                    <div style={this.styler.currStyles.Body.TextPage.Section}>
                        <p style={this.styler.currStyles.Body.TextPage.Section.title}>Here are some of my recent Financial and Insurance projects:</p>
                        <ProjectHistoryList filters={filters} displaycount={false}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default AndroidPlatform



// WEBPACK FOOTER //
// src/Industries/FinancialInsuranceIndustry.js